// extracted by mini-css-extract-plugin
export default {"add-group":"AlX1UzpxjsErffpdW1W5","icon":"TW4fWeMILxt0C4moGFwe"};